import RequestBuilder from "../RequestBuilder";
import {Method} from "../enum/Method";
import QualityCheckJson from "../json/QualityCheckJson"
import {ClassifierMetricsJson} from "../json/ClassifierMetricsJson"

export class QualityCheckRequests {
    static get(evalId: string): Promise<QualityCheckJson> {
        return new RequestBuilder(Method.Get, `quality-checks/${evalId}`)
            .buildAndSend()
    }

    static classifierMetrics(qualityCheckId: string): Promise<ClassifierMetricsJson | null> {
        return new RequestBuilder(Method.Get, `quality-checks/${qualityCheckId}/classifier-metrics`)
            .buildAndSend()
    }

    static restart(evalId: string): Promise<QualityCheckJson> {
        return new RequestBuilder(Method.Post, `quality-checks/${evalId}`)
            .buildAndSend()
    }

    static cancel(qualityCheckId: string): Promise<QualityCheckJson> {
        return new RequestBuilder(Method.Post, `quality-checks/${qualityCheckId}/cancel`)
            .buildAndSend()
    }
}